export default __webpack_public_path__ + "static/media/f_password.17f00c06.svg";